export default "__VITE_ASSET__feb0e3d9__"